import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modeSelect", "meetLinkSection", "coursePicker", "courseSummary", "courseSelect", "courseMenu", "courseOption"]

    connect() {
        this.updateMeetLinkVisibility()
        this.syncCourseOptions()
    }

    modeChanged() {
        this.updateMeetLinkVisibility()
    }

    toggleCourseMenu() {
        if (!this.hasCourseMenuTarget) return

        this.courseMenuTarget.classList.toggle("hidden")
    }

    closeCourseMenuOutside(event) {
        if (!this.hasCourseMenuTarget || this.courseMenuTarget.classList.contains("hidden")) return
        if (this.hasCoursePickerTarget && this.coursePickerTarget.contains(event.target)) return

        this.courseMenuTarget.classList.add("hidden")
    }

    toggleCourseOption(event) {
        if (!this.hasCourseSelectTarget) return

        const value = event.currentTarget.dataset.courseValue
        const option = Array.from(this.courseSelectTarget.options).find((item) => item.value === value)
        if (!option) return

        option.selected = !option.selected
        this.syncCourseOptions()
    }

    updateMeetLinkVisibility() {
        if (!this.hasMeetLinkSectionTarget) return
        if (!this.hasModeSelectTarget) {
            this.meetLinkSectionTarget.classList.remove("hidden")
            return
        }

        const mode = this.modeSelectTarget.value
        if (mode === "physical") {
            this.meetLinkSectionTarget.classList.add("hidden")
        } else {
            this.meetLinkSectionTarget.classList.remove("hidden")
        }
    }

    syncCourseOptions() {
        this.updateCourseSummary()
        this.updateCourseOptionStates()
    }

    updateCourseSummary() {
        if (!this.hasCourseSummaryTarget || !this.hasCourseSelectTarget) return

        const selected = Array.from(this.courseSelectTarget.selectedOptions)
        if (selected.length === 0) {
            this.courseSummaryTarget.textContent = "Select one or more courses"
            return
        }

        if (selected.length === 1) {
            this.courseSummaryTarget.textContent = selected[0].textContent.trim()
            return
        }

        this.courseSummaryTarget.textContent = `${selected.length} courses selected`
    }

    updateCourseOptionStates() {
        if (!this.hasCourseSelectTarget) return

        const selectedValues = new Set(Array.from(this.courseSelectTarget.selectedOptions).map((option) => option.value))

        this.courseOptionTargets.forEach((option) => {
            const selected = selectedValues.has(option.dataset.courseValue)
            option.classList.toggle("border-blue-400", selected)
            option.classList.toggle("bg-blue-50", selected)
            option.classList.toggle("text-blue-900", selected)
            option.classList.toggle("border-slate-200", !selected)
            option.classList.toggle("bg-white", !selected)
            option.classList.toggle("text-slate-700", !selected)
            option.setAttribute("aria-pressed", selected ? "true" : "false")

            const icon = option.querySelector("[data-course-selected-icon]")
            if (icon) icon.classList.toggle("hidden", !selected)
        })
    }
}
